import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($scope, httpSettings, $window, $q, claimViewModel, ModalService,
    DocumentService, StateUtils, endpointConfig, UserService, ServiceBoxInfoService) => {
    const ctrl = Object.create(BaseCtrl);
    const flowModel = StateUtils.activeDataForState(true).flowModel;

    ctrl.init = function () {
        $scope.claimVm = claimViewModel();
        $scope.claimVm.documents.value = $scope.claimVm.documents.value || [];
        $scope.removeFunction = (documentID) => DocumentService.removeDocument($scope.claimVm.claimNumber.value, documentID);
        $scope.metadataTemplate = {
            'DocUID': '001',
            'DocumentType': 'fnol',
            'SecurityType': 'unrestricted',
            'Status': 'approved',
            'Author': 'Repairer',
            'claimNumber': $scope.claimVm.claimNumber.value
        };

        $scope.claimCenterDownloadURI = httpSettings.serviceBaseURLs.cc + endpointConfig.downloadEndpoint;
        $scope.documentNotFoundURL = `${$window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'))}/ServiceRequestDocumentError`;
        $scope.uploadConfig = {
            htmlFile: 'puw-more-info.html',
            metadataTemplate: $scope.metadataTemplate,
            documentNotFoundUrl: $scope.documentNotFoundURL,
            xcenterCenterRetrievalUrl: $scope.claimCenterDownloadURI,
            documentUpload: 'cc',
            serviceName: endpointConfig.uploadEndpoint,
            sessionServiceName: endpointConfig.sessionServiceName,
            // Adding random number at end to make the class unique (multiple uploads on the page)
            uploaderClass: `gw-claim-common-file-upload-button${Math.floor(Math.random() * 9999)}`
        };
        $scope.IsSellerAndAvailableInAccountingTable = true;
        getProducerCodes();
    };

    function getProducerCodes() {
        const producerCodesPromise = UserService.getAvailableProducerCodesForCurrentUser();
        producerCodesPromise.then((producerCodesResponse) => {
            $scope.producerCodes = producerCodesResponse;
            if ($scope.producerCodes.length === 0 && $scope.claimVm.mainContact.isSeller.value === false
                && $scope.claimVm.mainContact.availableInAccountingTable.value === false) {
                console.log($scope.claimVm.mainContact.isSeller.value);
                console.log($scope.claimVm.mainContact.availableInAccountingTable.value);
                $scope.IsSellerAndAvailableInAccountingTable = false;
            }
        });
    }

    ctrl.defineWatches = () => {
        $scope.$watch('claimVm.documents.value', (newValue, oldValue) => {
            if (newValue !== oldValue) {
                const snapshot = flowModel.snapshot;
                snapshot.documents.value = newValue;
            }
        });
    };

    ctrl.next = function () {
        //UCWAR-543
        $scope.countQuoteDoc = 0;
        $scope.countWorkOrderDoc = 0;
        $scope.countDiagnosisDoc = 0;
        $scope.countIBANDoc = 0;
        $scope.claimVm.documents.value.forEach(function (document) {
            if (document.documentType === 'quote_psa') {
                $scope.countQuoteDoc++;
            }
            if (document.documentType === 'workorder_psa') {
                $scope.countWorkOrderDoc++;
            }
            if (document.documentType === 'diagnosis_psa') {
                $scope.countDiagnosisDoc++;
            }
            if (document.documentType === 'iban_psa') {
                $scope.countIBANDoc++;
            }
        });

        if ($scope.IsSellerAndAvailableInAccountingTable === false) { //UCWAR-533
            if (ServiceBoxInfoService.serviceQuoteTempData === undefined) {
                if ($scope.claimVm.lossCause.value.code != 'CarMaintenance_PSA' &&
                    ($scope.countQuoteDoc === 0 || $scope.countWorkOrderDoc === 0
                        || $scope.countDiagnosisDoc === 0 || $scope.countIBANDoc === 0)) {
                    const title = 'platform.widgets.fileupload.templates.Please upload mandatory documents including IBAN';
                    ModalService.showError(null, title);
                    return;
                }
                if ($scope.claimVm.lossCause.value.code === 'CarMaintenance_PSA' &&
                    ($scope.countQuoteDoc === 0 || $scope.countIBANDoc === 0)) {
                    const title = 'platform.widgets.fileupload.templates.Please upload mandatory document for Quote and IBAN';
                    ModalService.showError(null, title);
                    return;
                }
            } else {
                if ($scope.claimVm.lossCause.value.code != 'CarMaintenance_PSA' &&
                    ($scope.countWorkOrderDoc === 0 || $scope.countDiagnosisDoc === 0 || $scope.countIBANDoc === 0)) {
                    const title = 'platform.widgets.fileupload.templates.Please upload mandatory service box documents with IBAN';
                    ModalService.showError(null, title);
                    return;
                }
                if ($scope.claimVm.lossCause.value.code === 'CarMaintenance_PSA' && $scope.countIBANDoc === 0) {
                    const title = 'platform.widgets.fileupload.templates.Please upload mandatory service box document for IBAN';
                    ModalService.showError(null, title);
                    return;
                }
            }
        }

        //UCWAR-1731 - quote document not mandatory for service box claims
        if (ServiceBoxInfoService.serviceQuoteTempData === undefined) {
            //UCWAR-1363
            if ($scope.claimVm.lossCause.value.code === 'CarMaintenance_PSA' && $scope.countQuoteDoc === 0) {
                const title = 'platform.widgets.fileupload.templates.Please upload mandatory document for Quote';
                ModalService.showError(null, title);
                return;
            }
            if ($scope.claimVm.lossCause.value.code != 'CarMaintenance_PSA' && ($scope.countQuoteDoc === 0
                || $scope.countWorkOrderDoc === 0 || $scope.countDiagnosisDoc === 0)) {
                const title = 'platform.widgets.fileupload.templates.Please upload mandatory documents';
                ModalService.showError(null, title);
                return;
            }
        } else if ($scope.countWorkOrderDoc === 0 || $scope.countDiagnosisDoc === 0) {
            const title = 'platform.widgets.fileupload.templates.Please upload mandatory service box documents';
            ModalService.showError(null, title);
            return;
        }

        flowModel.next($scope.claimVm);
    };

    ctrl.previous = function () {
        flowModel.previous($scope.claimVm);
    };

    ctrl.cancel = function () {
        flowModel.cancel($scope.claimVm);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'httpSettings', '$window', '$q', 'claimViewModel', 'ModalService', 'claim.DocumentService', 'StateUtils', 'claim.endpointConfig', 'UserService', 'ServiceBoxInfoService'];

export default fn;